import React, { Component }  from 'react';
import Footer from '../components/layout/footer';
import Header from '../components/layout/header';
import AboutUs from '../components/section/about_us';
import Beyond from '../components/section/beyond_academics';
import Cbse from '../components/section/cbse';
import LifeAtInnovera from '../components/section/life_at_innovera';
  import config from '../constant';


class LifeInnoveraMain extends Component {
    componentDidMount(){
        document.title = "Why Innovera | " + config.SIE_NAME
      }
        render(){
    return(
        <div>
            <Header/>
            <LifeAtInnovera/>
             <Footer/>


        </div>
    );

}
    }
export default LifeInnoveraMain;